document.addEventListener("DOMContentLoaded", function () {
  const forms = document.querySelectorAll(".signup-form");

  forms.forEach((form) => {
    form.addEventListener("submit", async function (e) {
      e.preventDefault();

      const emailInput = form.querySelector('input[name="email"]');
      const listIdInput = form.querySelector('input[name="g"]');
      const gdprInput = form.querySelector('input[type="checkbox"]');

      const errorBox = form.querySelector(".form-notification.error");
      const successBox = form.querySelector(".form-notification.success");

      // Hide previous messages
      errorBox.style.display = "none";
      successBox.style.display = "none";

      const email = emailInput.value.trim();
      const listId = listIdInput.value;

      if (!email || !listId || (gdprInput && !gdprInput.checked)) {
        errorBox.style.display = "block";
        return;
      }

      try {
        const formData = new URLSearchParams();
        formData.append("email", email);
        formData.append("g", listId);

        const res = await fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formData.toString(),
        });

        const data = await res.json();

        if (data.success) {
          successBox.style.display = "block";
          emailInput.value = "";
          if (gdprInput) gdprInput.checked = false;
        } else {
          errorBox.style.display = "block";
        }
      } catch (err) {
        errorBox.style.display = "block";
      }
    });
  });
});
